export default "__VITE_ASSET__YGh_2Hra__"